export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row">
      <div className="w-full lg:w-1/2 relative min-h-[400px] lg:min-h-[550px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20still%20life%20with%20a%20pair%20of%20premium%20dark%20brown%20leather%20Chelsea%20boots%20positioned%20elegantly%20beside%20a%20folded%20charcoal%20grey%20wool%20overcoat%2C%20a%20classic%20tan%20leather%20belt%20coiled%20loosely%2C%20and%20a%20textured%20woven%20wool%20scarf%20draped%20across%20warm%20oak%20wooden%20surface%2C%20soft%20directional%20studio%20lighting%20from%20left%20creating%20dimensional%20shadows%2C%20refined%20editorial%20aesthetic%20with%20rich%20autumnal%20earth%20tones%20of%20caramel%20cognac%20and%20charcoal%2C%20luxury%20fashion%20catalog%20style%20photography%2C%20sophisticated%20minimal%20composition%2C%20high%20detail%20with%20visible%20leather%20grain%20and%20textile%20weave&width=900&height=700&seq=cta-fashion-v2-20260712&orientation=portrait"
          alt="Hipobuy Spreadsheet Main Store"
          title="Visit Hipobuy Spreadsheet Main Store"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-8 md:p-12">
          <span className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm text-white text-xs font-semibold rounded-full mb-3">
            Main Store
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight">
            Ready To <br />Shop <br />Smarter?
          </h2>
        </div>
      </div>

      <div className="w-full lg:w-1/2 bg-white flex items-center justify-center py-16 md:py-20 px-6 md:px-12">
        <div className="max-w-md text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            Visit Kaspreadsheet <br />Main Store
          </h2>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6">
            Explore the complete product database with thousands of organized items across fashion, accessories, sneakers, and lifestyle categories. The main store features real-time inventory, detailed product information, and an intuitive browsing experience built on the hipobuy spreadsheet methodology.
          </p>
          <p className="text-sm text-foreground-400 mb-8">
            Updated daily with fresh arrivals and trending products.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-10 py-4 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all hover:scale-[1.02] whitespace-nowrap"
          >
            Hipobuy Sheet
            <i className="ri-arrow-right-line"></i>
          </a>
          <p className="text-xs text-foreground-400 mt-4">
            Opens in new window &middot; Secure connection
          </p>
        </div>
      </div>
    </section>
  );
}